import { DocumentSummary } from "@/types/document";

import { requestData } from "@/api/api-config";

export async function getNoteDocuments(
  noteId: string,
): Promise<DocumentSummary[] | null> {
  return await requestData<DocumentSummary[]>(
    `notes/${noteId}/documents`,
    "get",
  );
}

export async function uploadNoteDocument(
  noteId: string,
  file: File,
  title: string,
  docType: string = "Other",
): Promise<DocumentSummary | null> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("title", title);
  formData.append("doc_type", docType);

  return await requestData<DocumentSummary>(
    `notes/${noteId}/documents/upload`,
    "post",
    { body: formData },
  );
}

export async function linkDocumentsToNote(
  noteId: string,
  documentIds: string[],
): Promise<DocumentSummary[] | null> {
  return await requestData<DocumentSummary[]>(
    `notes/${noteId}/documents/link`,
    "post",
    { json: { document_ids: documentIds } },
  );
}

export async function unlinkDocumentFromNote(
  noteId: string,
  documentId: string,
): Promise<{ message: string } | null> {
  return requestData<{ message: string }>(
    `notes/${noteId}/documents/${documentId}`,
    "delete",
  );
}
